import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import "./email.scss";
import { FormikTextField } from "app/components/form/FormikTextField/FormikTextField";

const Email = ({ readOnly, blocPrefixName = "" }) => {
	return (
		<div className="email">
			<FormikTextField
				type="email"
				name={blocPrefixName ? `${blocPrefixName.toLowerCase()}.email` : "email"}
				id="email"
				data-testid="email-input"
				label={<FormattedMessage id="email.label" />}
				readOnly={readOnly}
				maxLength={100}
			/>
		</div>
	);
};

Email.propTypes = { readOnly: PropTypes.bool, blocPrefixName: PropTypes.string };

export default Email;
